var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from 'vue-property-decorator';
import Promise from 'bluebird';
import linker from '../linker';
import Helper from '../riHelper';
import showError from '../central/showError';
import { every } from '../central/enumerableExtensions';
import CacheLayer from '../central/services/cacheLayer';
import { TaxonomyHelper } from '../services/TaxonomyHelper';
import { encodeHTML } from '../../../../RUB.Serviceportal.MySharePoint/ClientApp/src/utils';
import { throttle } from 'lodash';
var RightNavi = (function (_super) {
    __extends(RightNavi, _super);
    function RightNavi() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loaded = false;
        _this.navItems = [];
        _this.hoveredLink = null;
        _this.isMobile = false;
        _this.showRightNavMobile = false;
        _this.eventOnScroll = function () {
            var eOuter = _this.$refs.outer;
            var eInner = _this.$refs.inner;
            eInner.style.top = _this.scrollHost.offsetTop + "px";
            var willBeSticky = _this.scrollHost.scrollTop > eOuter.offsetTop;
            var isSticky = eInner.classList.contains('sticky');
            if (isSticky != willBeSticky) {
                if (willBeSticky) {
                    eInner.classList.add('sticky');
                }
                else {
                    eInner.classList.remove('sticky');
                }
            }
        };
        _this.scrollHostTop = 0;
        _this.eventOnScrollMobile = function () {
            var maxScrollTop = _this.scrollHost.scrollHeight - _this.scrollHost.offsetHeight;
            var scrollDir = _this.scrollHostTop - _this.scrollHost.scrollTop;
            _this.showRightNavMobile = false;
            _this.scrollHostTop = _this.scrollHost.scrollTop;
            if (_this.scrollHost.scrollTop >= maxScrollTop && scrollDir > 0) {
                return;
            }
            else if (_this.scrollHost.scrollTop <= 0 && scrollDir < 0) {
                return;
            }
            var mobileNav = _this.$refs.mobileNav;
            if (scrollDir < 0) {
                mobileNav.classList.add('hideLabel');
            }
            else if (scrollDir > 0) {
                mobileNav.classList.remove('hideLabel');
            }
        };
        _this.throttledEventOnScrollMobile = throttle(_this.eventOnScrollMobile, 100);
        _this.toggleNaviMobile = function () {
            _this.showRightNavMobile = !_this.showRightNavMobile;
            var eOuter = _this.$refs.outer;
            var toggleButtonLabel = _this.$refs.mobileToggleButtonLabel;
            var toggleButtonIcon = _this.$refs.mobileToggleButtonIcon;
            var mobileBackground = _this.$refs.mobileBackground;
            var mobileNav = _this.$refs.mobileNav;
            clearTimeout(_this.hidingNaviMobile);
            if (!_this.showRightNavMobile) {
                _this.hidingNaviMobile = setTimeout(function () {
                    eOuter.classList.add('hidden');
                    mobileBackground.classList.add("hidden");
                }, 500);
                eOuter.classList.remove('open');
                eOuter.classList.add('close');
                mobileBackground.classList.remove("open");
                mobileBackground.classList.add("close");
                toggleButtonLabel.innerText = "Mehr";
                if (_this.scrollHost.scrollTop !== 0) {
                    mobileNav.classList.add('hideLabel');
                }
                toggleButtonIcon.innerHTML = '<path fill="#17365c" d="M16,12A2,2 0 0,1 18,10A2,2 0 0,1 20,12A2,2 0 0,1 18,14A2,2 0 0,1 16,12M10,12A2,2 0 0,1 12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12M4,12A2,2 0 0,1 6,10A2,2 0 0,1 8,12A2,2 0 0,1 6,14A2,2 0 0,1 4,12Z"/>';
            }
            else {
                eOuter.classList.remove('hidden');
                mobileBackground.classList.remove("hidden");
                eOuter.classList.remove('close');
                eOuter.classList.add('open');
                mobileBackground.classList.remove("close");
                mobileBackground.classList.add("open");
                mobileNav.classList.remove('hideLabel');
                toggleButtonLabel.innerText = "Weniger";
                toggleButtonIcon.innerHTML = '<path fill="#17365c" d="M12,16A2,2 0 0,1 14,18A2,2 0 0,1 12,20A2,2 0 0,1 10,18A2,2 0 0,1 12,16M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M12,4A2,2 0 0,1 14,6A2,2 0 0,1 12,8A2,2 0 0,1 10,6A2,2 0 0,1 12,4Z"/>';
            }
        };
        return _this;
    }
    Object.defineProperty(RightNavi.prototype, "scrollHost", {
        get: function () {
            return document.getElementById('s4-workspace');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RightNavi.prototype, "rootUrl", {
        get: function () {
            return _spPageContextInfo.siteAbsoluteUrl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RightNavi.prototype, "navEmptyItemsNarrow", {
        get: function () {
            if (!this.navItems)
                return [];
            var amount = 3 - this.navItems.filter(function (i) { return i.bottomBarPosition != 1; }).length % 3;
            if (amount == 3)
                return [];
            return new Array(amount).fill(null);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RightNavi.prototype, "navEmptyItemsWide", {
        get: function () {
            if (!this.navItems)
                return [];
            var amount = 4 - this.navItems.filter(function (i) { return !i.bottomBarPosition; }).length % 4;
            if (amount == 4)
                return [];
            return new Array(amount).fill(null);
        },
        enumerable: true,
        configurable: true
    });
    RightNavi.prototype.getBottomBarItemHtmlViaPosition = function (position) {
        var result = '';
        if (this.navItems) {
            var item = this.navItems.find(function (i) { return i.bottomBarPosition === position; });
            if (!item) {
                item = this.navItems.find(function (i) { return i.bottomBarPosition === undefined; });
                if (item) {
                    item.bottomBarPosition = position;
                }
            }
            if (item) {
                result = "<a href=\"" + item.url + "\">" + item.svg + "<span class=\"riRightNavMobileLabel\">" + encodeHTML(item.label) + "</span></a>";
            }
        }
        return result;
    };
    RightNavi.prototype.mounted = function () {
        var _this = this;
        window.$itacs.helper.pageLoaded().then(function () {
            _this.load();
            _this.setMobile(window.$servicePortal.isMobile);
            window.addEventListener('riResponsive', function (evnt) {
                _this.setMobile(!!evnt.detail.isMobile);
            });
        });
    };
    RightNavi.prototype.setMobile = function (isMobile) {
        this.scrollHost.removeEventListener('scroll', this.throttledEventOnScrollMobile);
        this.scrollHost.removeEventListener('scroll', this.eventOnScroll);
        if (isMobile) {
            this.scrollHost.addEventListener('scroll', this.throttledEventOnScrollMobile);
        }
        else {
            this.scrollHost.addEventListener('scroll', this.eventOnScroll);
        }
        this.isMobile = isMobile;
    };
    RightNavi.prototype.beforeDestroy = function () {
        this.scrollHost.removeEventListener('scroll', this.throttledEventOnScrollMobile);
        this.scrollHost.removeEventListener('scroll', this.eventOnScroll);
    };
    RightNavi.prototype.load = function () {
        var _this = this;
        if (SP.Guid.isValid(this.termSetId)) {
            this.loadTerms().then(function (items) { _this.navItems = items; }).catch(function (error) {
                showError(error);
            });
        }
        else {
            showError('RightNaviTermSetId in Portalkonfiguration ist nicht gesetzt oder keine GUID!');
        }
    };
    RightNavi.prototype.getStyle = function (item) {
        var style = { fill: item.color, color: item.color, backgroundColor: item.backgroundColor, borderColor: item.borderColor };
        if (this.hoveredLink === item) {
            style.backgroundColor = item.hoverColor;
        }
        return style;
    };
    RightNavi.prototype.checkIfUserIsEditor = function (webUrl) {
        return new Promise(function (resolve) {
            Helper.context().then(function () {
                var ctx = new SP.ClientContext(_spPageContextInfo.siteAbsoluteUrl + '/' + webUrl.replace(/^\/*(.*?)\/*$/g, '$1'));
                var lib = ctx.get_web().get_lists().getByTitle('Seiten');
                ctx.load(lib, 'EffectiveBasePermissions');
                Helper.clientContextExecute(ctx).then(function () {
                    var permissions = lib.get_effectiveBasePermissions();
                    SP.PermissionKind.editListItems;
                    resolve(permissions.has(3));
                }).catch(function () { resolve(false); });
            });
        });
    };
    RightNavi.prototype.loadTerms = function () {
        var _this = this;
        return CacheLayer.simpleLoad(function () {
            return new Promise(function (resolve, reject) {
                Helper.taxSession().then(function (_a) {
                    var tax = _a.tax, termStore = _a.termStore;
                    var ctx = tax.get_context();
                    var termSet = termStore.getTermSet(new SP.Guid(_this.termSetId));
                    ctx.load(termSet);
                    var terms = termSet.get_terms();
                    ctx.load(terms);
                    return Helper.clientContextExecute(ctx).then(function () {
                        var result = [];
                        var ps = [];
                        every(terms, function (currentTerm, index) {
                            var properties = currentTerm.get_customProperties();
                            var localProps = currentTerm.get_localCustomProperties();
                            var label = TaxonomyHelper.tryGetLabelWithHyphen(currentTerm);
                            var p = Promise.resolve(true);
                            var editorWeb = properties['Abgesichert'];
                            if (editorWeb) {
                                p = _this.checkIfUserIsEditor(editorWeb);
                            }
                            p.then(function (visible) {
                                if (visible) {
                                    var mobileOnlyValue = (properties['Nur-Mobil'] || '').toLowerCase();
                                    var bottomBarPositionValue = parseInt(properties['BottomBar-Position']);
                                    var navItem = {
                                        label: label,
                                        backgroundColor: properties['Hintergrundfarbe'] || '#17365c',
                                        color: properties['Farbe'] || '#fff',
                                        hoverColor: properties['Hover-Farbe'] || '#1e5178',
                                        borderColor: properties['Randfarbe'] || '#fff',
                                        url: localProps['_Sys_Nav_SimpleLinkUrl'] || '#',
                                        svg: properties['SVG'] || '',
                                        order: index,
                                        mobileOnly: mobileOnlyValue == 'true' || mobileOnlyValue == '1' || mobileOnlyValue == 'ja',
                                        bottomBarPosition: isNaN(bottomBarPositionValue) ? undefined : bottomBarPositionValue,
                                    };
                                    result.push(navItem);
                                }
                            });
                            ps.push(p);
                        });
                        Promise.all(ps).then(function () {
                            resolve(result.sort(function (a, b) { return a.order - b.order; }));
                        });
                    });
                }).catch(reject);
            });
        }, 'rightNavi');
    };
    __decorate([
        Prop()
    ], RightNavi.prototype, "termSetId", void 0);
    RightNavi = __decorate([
        Component({})
    ], RightNavi);
    return RightNavi;
}(Vue));
export default RightNavi;
linker.register('rightNavi', RightNavi);
